import React, { FC } from 'react';
import { useEffect, useState } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { api } from 'services/api';
import { Company } from 'types/company';
import { initialCompany, initialMeta } from 'services/initialStates';
import { CompanyMainPage } from 'client/pages/Main/CompanyMainPage';
import { Meta } from 'types/meta';
import { Loading } from 'common/components/Loading';
import { LoadingError } from 'common/components/LoadingError';
import { useTranslation } from 'react-i18next';
import { FormPage } from 'client/pages/Form/FormPage';
import { QrType } from 'types/qrType';
import { BackgroundImage } from 'styles/BackgroundImage';
import { FullScreen } from 'styles/FullScreen';
import { MenuPage } from 'client/pages/MenuPage';
import { ActionSentPage } from 'client/pages/ActionSentPage';

export const CompanyDispatcher: FC<{ qrType: QrType }> = ({ qrType }) => {
  const { hash } = useParams() as { hash: string };
  const [meta, setMeta] = useState<Meta>(initialMeta);
  const [company, setCompany] = useState<Company>(initialCompany);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    api()
      .getCompany(hash, qrType)
      .then(response => {
        if (response.error) setLoadingError(true);
        else {
          setCompany(response.data);
          setMeta(response.meta);
          setLoading(false);
        }
      });
  }, []);

  if (loading) return <Loading />;
  if (loadingError)
    return <LoadingError error={t('failedToRetrieveCompanyData')} />;
  return (
    <FullScreen>
      <BackgroundImage source={meta.background} />
      <Routes>
        <Route
          path="/"
          element={
            <CompanyMainPage
              company={company}
              meta={meta}
              qrType={qrType}
              hash={hash}
            />
          }
        />
        <Route
          path="feedback"
          element={
            <FormPage
              entity={company}
              meta={meta}
              qrType={qrType}
              preview={false}
            />
          }
        />
        <Route
          path="menu/:id"
          element={<MenuPage entity={company} company={company} meta={meta} />}
        />
        <Route path="/launch_action" element={<ActionSentPage meta={meta} />} />
      </Routes>
    </FullScreen>
  );
};
